<template>
  <div class="background-image">
    <div class="section frosty-background d-none d-lg-block" />

    <!-- Hero content -->
    <div class="overlay">
      <b-container class="hero-container" fluid>
        <b-row>
          <b-col md="12" :lg="heroColumnWidth.leftColLg" class="my-auto p-3 px-sm-5 py-sm-0">
            <div class="d-flex">
            <!--div class="d-flex" v-if="eyebrow.icon || eyebrow.title"-->
              <div class="eyebrow-icon-wrapper" v-if="hero.eyebrowIcon">
                <b-img :src="require('../assets/' + hero.eyebrowIcon)" />
                <!--b-img :src="require('../assets/' + eyebrow.icon)" /-->
              </div>
              <div class="ml-2 my-auto">
                <img 
                  v-if="($route.path === '/') || 
                  ($route.path === '/Aconex') || 
                  ($route.path === '/Aconex/register') || 
                  ($route.path === '/Aconex/find-information-fast') "
                  src="./../assets/oracle-partner-600px.png" 
                  style="width: 264px;" 
                />
                <!--*** eyebrow-title with RouterLink ***-->
                <RouterLink to="/building-knowledge-accelerator" v-if="($route.path === '/') || ($route.path === '/trinpod-server') || ($route.path === '/trinapp')">
                  <p class="mb-0 lead" :class="{ 'eyebrow-title' : ($route.path === '/' || $route.path === '/trinpod-server' || $route.path === '/trinapp') }">
                    {{ hero.eyebrowTitle }}
                  </p>
                </RouterLink>
                <!--RouterLink to="/building-knowledge-accelerator" v-if="($route.path === '/') || ($route.path === '/trinpod-server') || ($route.path === '/trinapp')">
                  <p class="mb-0 lead" :class="{ 'eyebrow-title' : ($route.path === '/' || $route.path === '/trinpod-server' || $route.path === '/trinapp') }">
                    <{{ eyebrow.title }}>
                  </p>
                </RouterLink-->
                <!--*** eyebrow-title without RouterLink ***-->
                <p class="mb-0 lead" :class="{ 'eyebrow-title' : ($route.path === '/' || $route.path === '/trinpod-server' || $route.path === '/trinapp') }" v-if="($route.path !== '/') && ($route.path !== '/trinpod-server') && ($route.path !== '/trinapp')">
                  <!--{{ eyebrow.title }}--> {{ hero.eyebrowTitle }}
                </p>
                <p  class="mb-0 eyebrow-subtitle" v-if="hero.eyebrowSubtitle">
                  <!--{{ hero.eyebrow }}--> {{ hero.eyebrowSubtitle }}
                </p>
                <!--p  class="mb-0 eyebrow-subtitle" v-if="hero.eyebrow">
                  <{{ hero.eyebrow }}> {{ hero.eyebrowSubtitle }}
                </p-->
              </div>
            </div>
            <h1 :class="[ windowWidth < 576 ? 'display-5' : 'display-4']">
              {{ hero.header }}
            </h1>
            <p class="lead">
              {{ hero.subheader }}
            </p>
            <div class="lead" v-html="hero.html" v-if="hero.html" />
            <!-- Hero buttons for home page only -->
            <div class="problems-btn-wrapper" v-if="$route.path === '/'">
              <!--b-button
                class="w-100 text-left font-weight-bold"
                style="text-overflow: ellipsis; overflow: hidden; white-space: no-wrap;"
                v-for="button in hero.buttons" 
                :key="button.label"
                variant="light"
                @click="scrollTo(button.id)"
              >
                {{ button.label }}
              </b-button-->
              <b-button v-for="button in hero.buttons" 
                :key="button.label"
                class="text-left font-weight-bold mr-2"
                variant="neon-blue"
                :to="button.path"
              >
                {{ button.label }}
              </b-button>
              <b-button 
                class="font-weight-bold mr-2"
                variant="neon-blue"
                @click="scrollTo('trinpod-server')"
              >
                TrinPod&trade; Server
              </b-button>
              <b-button 
                class="font-weight-bold"
                variant="neon-blue"
                @click="scrollTo('trinapp-suite')"
              >
                TrinApp&trade; Suite
              </b-button>
            </div>
            
            <!-- Hero buttons for all other pages-->
            <div class="hero-btn-wrapper" v-if="$route.path !== '/'">
              <b-button v-for="button in hero.buttons" 
                :key="button.label"
                class="mr-2"
                variant="neon-blue"
                @click="scrollTo(button.id)"
              >
                {{ button.label }}
              </b-button>
            </div>

            <!-- Solid page hero buttons -->
            <div class="hero-btn-wrapper" v-if="$route.path !== '/' && $route.path === '/solid'">
              <b-button 
                class="mr-2"
                style="text-decoration: none; padding-left: 0px !important;"
                variant="link"
                size="lg"
                @click.native="scrollToTop"
              >
                <b-link 
                  class="text-dark"
                  href="https://solidproject.org/" 
                  target="_blank"
                >
                  Learn More 
                  <font-awesome-icon :icon="faArrowRight" />
                </b-link>
              </b-button>
            </div>

            <!-- Aconex landing hero button -->
            <div class="hero-btn-wrapper" v-if="$route.path !== '/' && $route.path === '/Aconex'">
              <b-button 
                class="mr-2"
                style="text-decoration: none; padding-left: 0px !important;"
                variant="link"
                size="lg"
                @click.native="scrollToTop"
              >
                <b-link 
                  class="text-dark"
                  to="/Aconex/help" 
                  target="_blank"
                >
                  Accelerator Help
                  <font-awesome-icon :icon="faArrowRight" />
                </b-link>
              </b-button>
            </div>

            <div class="hero-btn-wrapper" v-if="$route.path !== '/' && $route.path === '/Aconex/help'">
              <b-button
                id="btn-help-chat"
                class="text-left font-weight-bold mr-2"
                variant="neon-blue"
                onclick="$zoho.salesiq.floatwindow.visible('show')" 
              >
                Live Chat
              </b-button>
            </div>
          </b-col>

          <!-- Media column -->
          <b-col md="12" :lg="heroColumnWidth.rightColLg" class="my-auto pb-3 pb-md-0" v-if="hero.videoId">
            <vimeo-player 
              :video-id='hero.videoId'
              :options="{ 
                responsive: true,
              }"
            />
          </b-col>
          <b-col md="12" lg="7" class="my-auto pb-3 pb-md-0" v-if="!hero.videoId && hero.img">
            <b-img 
              :src="require('../assets/' + hero.img)" 
              fluid
              class="mx-auto"
              style="max-height: 590px;" 
            />
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import { vueWindowSizeMixin } from "vue-window-size";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
export default {
  name: 'Hero',
  props: {
    hero: Object
  },
  mixins: [vueWindowSizeMixin],
  data() {
    return {
      faArrowRight
    }
  },
  components: {
    FontAwesomeIcon
  },
  computed: {
    eyebrow() {
      var icon;
      var title;
      switch(this.$route.path) {
        case ('/'):
          icon = '';
          title = '';
          break
        case ('/building'):
          icon = 'trinity_construction.png';
          title = 'Building';
          break
        case ('/productivity'):
          icon = 'trinity.png';
          title = 'Productivity';
          break
        case ('/property'):
          icon = 'trinity_properties_hat.png';
          title = 'Property Management';
          break
        case ('/documents'):
          icon = 'trinapp_cde.png';
          title = 'TrinApp\u2122 Documents';
          break
        case ('/projects'):
          icon = 'trinapp_projects.png';
          title = 'Pods';
          break
        case ('/intelligent-pdf'):
          icon = 'icon-ipdf.png';
          title = 'IntelligentPDF';
          break
        case ('/trinpod'):
          icon = 'trinity_secure.png';
          title = 'TrinPod\u2122';
          break
        case ('/solid'):
          icon = 'solid_logo_tr.png';
          title= 'Solid';
          break
        case ('/building-knowledge-accelerator'):
          icon = 'trinity_construction.png';
          title = 'TrinPod\u2122 Server + TrinApp\u2122 Suite';
          break
        case ('/trinapp'):
          icon = 'launchpad.png';
          title = 'The Building Knowledge Accelerator';
          break
        case ('/trinpod-server'):
          icon = 'trinity_secure.png';
          title = 'The Building Knowledge Accelerator';
          break
        case ('/trinapp-search'):
          icon = 'trinity_secure.png';
          title = 'TrinApp\u2122 Suite';
          break
        case ('/Aconex/register'):
          icon = 'trinapp_crosslink.png';
          title = 'Oracle Partner';
          break
        default:
          icon = 'trinity_construction.png';
          title = 'The Building Knowledge Accelerator';
      }
      return {'icon': icon, 'title': title};
    },
    hasEyebrow() {
      if (
        this.$route.path === '/building' ||
        this.$route.path === '/productivity' ||
        this.$route.path === '/property'
      ) {
        return true;
      }
    },
    heroColumnWidth() {
      var leftColLg = 5;
      var rightColLg = 7;
      if (this.$route.path === '/') {
        leftColLg = 6;
        rightColLg = 6;
      }
      return { leftColLg, rightColLg }
    }
  },
  methods: {
    scrollTo: function(id) {
      document.getElementById(id).scrollIntoView({ behavior: 'smooth' });
    },
  }
};
</script>

<style scoped>
.jumbotron {
  background-color: transparent;
}
.background-image {
  background-color: #ffffff;
  background-image: url("../assets/hero-bg.png");
  background-repeat: no-repeat; 
  background-position: center center;
  background-size: cover;
}
.frosty-background {
  background: linear-gradient(180deg, rgba(207,207,207,0),85%, rgba(207,207,207,1) 100%);
}
.overlay { 
  z-index: 2;
  left: 0;
  top: 62px; 
  display: flex;
  background-color: #ffffff95;
}
.hero-container {
  margin-top: auto;
  margin-bottom: auto;
}
.eyebrow-icon-wrapper {
  width: 76px;
  height: 76px;
}
.eyebrow-icon-wrapper > img {
  height: 70px;
}
@media (min-width: 576px) {
  .hero-container {
    padding: 2rem 3rem !important;
  }
}
@media (max-width: 767px) {
  .hero-btn-wrapper > .btn {
    width: 100%;
  }
}
@media (min-width: 992px) {
  .overlay {
    position: absolute;
    /* 15px is bootstrap right margin */
    width: calc(100vw - 15px);
    /* 62px is the navbar height */
    min-height: 100vh;
  }
}
</style>
